import { connect } from 'react-redux'

import { RootState } from '../types'
import { Sidebar } from '../components/Sidebar'
import { MT4Connector, ModifyTrade, TradeType, TradeCommandType } from '@bdswiss/mt4-connector'
import { TradingAction, selectPosition } from '../actions'
import {
  closeTrade,
  cancelPendingOrder,
  inputPositionPrice,
  modifyTrade,
  inputPositionSL,
  inputPositionTP,
} from '../actions/TradeActions'
import { setTradingSymbol } from '../actions/commonActions'
import { setModal } from '../actions/dialogActions'
import { I18n } from 'react-redux-i18n'
import { updateFavourites } from '../actions/GraphQLActions'
import { Dispatch } from 'redux'

const mt4 = MT4Connector.Instance

function mapStateToProps(rootState: RootState) {
  const { appState } = rootState
  return {
    locale: rootState.appConfig.locale
      ? rootState.appConfig.locale
      : rootState.tradingAccounts.viewer.locale,
    accountLoaded: appState.accountLoaded,
    assetsOpened: appState.assetsOpened,
    positionsOpened: appState.positionsOpened,
    tradingPaneOpened: appState.tradingPaneOpened,
    editPaneOpened: appState.editPaneOpened,
    sidebarOpened: appState.sidebarOpened,
    assets: mt4.assets,
    positions: mt4.positions,
    pendingOrders: mt4.pendingOrders,
    positionsInputs: rootState.positionsInputs,
    tradeOperationEnabled: rootState.tradingPane.tradeOperationEnabled,
    currency: appState.currency,
    favourites: rootState.favourites,
    appMode: appState.appMode,
    selectedPosition: appState.selectedPosition,
    positionExpanded: appState.positionExpanded,
    selectedOrder: appState.selectedOrder,
    orderExpanded: appState.orderExpanded,
  }
}

function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onModifyTrade: ({ order, uuid, sl, tp, price }: ModifyTrade, tradeType: TradeType) =>
      dispatch(modifyTrade(order, uuid, sl, tp, tradeType, price)),
    onCloseTrade: (order: number, uuid?: string) =>
      dispatch(
        setModal(I18n.t(`closingPosition`), I18n.t('closePositionMessage'), closeTrade(order, uuid))
      ),
    onCancelPendingOrder: (order: number, uuid?: string) =>
      dispatch(
        setModal(
          I18n.t(`closingPosition`),
          I18n.t('closePositionMessage'),
          cancelPendingOrder(order, uuid)
        )
      ),
    onInputPrice: (order: number, value: number) => dispatch(inputPositionPrice(order, value)),
    onInputStopLoss: (order: number, value: number) => dispatch(inputPositionSL(order, value)),
    onInputTakeProfit: (order: number, value: number) => dispatch(inputPositionTP(order, value)),
    onToggleFavourite: (favourites: string[]) => dispatch(updateFavourites(favourites)),
    onShowChart: (symbol: string, tradeType: TradeCommandType) =>
      dispatch(setTradingSymbol(symbol, tradeType)),
    onSelectPosition: (order: number, expanded?: boolean) =>
      dispatch(selectPosition(order, expanded)),
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar)
